import { render, staticRenderFns } from "./TabelaContratosRematricula.vue?vue&type=template&id=1061e031&scoped=true&"
import script from "./TabelaContratosRematricula.vue?vue&type=script&lang=js&"
export * from "./TabelaContratosRematricula.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1061e031",
  null
  
)

export default component.exports